export default "__VITE_ASSET__CF1ofkAe__"